import { render, staticRenderFns } from "./_base-requester-email.vue?vue&type=template&id=edbe4c20&scoped=true&"
import script from "./_base-requester-email.vue?vue&type=script&lang=js&"
export * from "./_base-requester-email.vue?vue&type=script&lang=js&"
import style0 from "./_base-requester-email.vue?vue&type=style&index=0&id=edbe4c20&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edbe4c20",
  null
  
)

export default component.exports